import { useState } from "react";
import { Group, Line, Circle, Rect, Label, Tag, Text } from "react-konva";
import { editableFields, moveField, resizeField, fieldBox } from "@/editor/fieldOps";

import { tr } from "@/lib/i18n";
// Campi moduli sul disegno (passo Bozza): clic = seleziona; trascina il campo = sposta (resta nel tetto);
// maniglie quadrate sui lati = riduci/allarga a moduli interi; maniglie tonde = vertici del contorno.
export const FieldLayer = ({ layout, sel, scale, llToWorld, toLL, canEdit, onSelect, onCommit }) => {
  const [prev, setPrev] = useState(null); // { rid, i, poly, text }
  const ptrUV = (e, f) => { const w = e.target.getStage().getRelativePointerPosition(); return f.frame.toUV(toLL(w)); };
  const s = 1 / scale;
  return (
    <Group>
      {layout.fields.flatMap((f) => editableFields(f.roof).map((poly0, i) => ({ f, poly0, i })))
        .sort((a, b) => Number(!!sel && sel.rid === a.f.roof.id && sel.i === a.i) - Number(!!sel && sel.rid === b.f.roof.id && sel.i === b.i))
        .map(({ f, poly0, i }) => {
        const isSel = sel && sel.rid === f.roof.id && sel.i === i;
        const live = prev && prev.rid === f.roof.id && prev.i === i ? prev.poly : poly0;
        const pts = live.map(llToWorld);
        const [U0, U1, V0, V1] = fieldBox(f, live);
        const mids = { l: [U0, (V0 + V1) / 2], r: [U1, (V0 + V1) / 2], b: [(U0 + U1) / 2, V0], t: [(U0 + U1) / 2, V1] };
        const done = (poly) => { setPrev(null); onCommit(f.roof, i, poly); };
        return (
          <Group key={`fld-${f.roof.id}-${i}`}>
            <Line name={`field-${f.roof.id}-${i}`} points={pts.flat()} closed fill={isSel ? "rgba(34,211,238,0.16)" : "rgba(34,211,238,0.06)"}
              stroke="#22d3ee" strokeWidth={(isSel ? 2.4 : 1.6) * s} dash={isSel ? undefined : [8 * s, 5 * s]}
              draggable={canEdit && isSel} listening={canEdit}
              onClick={(e) => { e.cancelBubble = true; onSelect(f.roof.id, i); }} onTap={() => onSelect(f.roof.id, i)}
              onDragStart={(e) => { e.target.setAttr("start", ptrUV(e, f)); }}
              onDragMove={(e) => {
                const a = e.target.getAttr("start"), b = ptrUV(e, f);
                e.target.position({ x: 0, y: 0 });
                setPrev({ rid: f.roof.id, i, poly: moveField(f, poly0, b[0] - a[0], b[1] - a[1]) });
              }}
              onDragEnd={() => prev && done(prev.poly)}
              onMouseEnter={(e) => { if (canEdit) e.target.getStage().container().style.cursor = isSel ? "move" : "pointer"; }}
              onMouseLeave={(e) => { e.target.getStage().container().style.cursor = ""; }} />
            {isSel && canEdit && Object.entries(mids).map(([side, q]) => {
              const w = llToWorld(f.frame.toLL(q));
              return <Rect key={side} name={`field-size-${side}`} x={w[0] - 6 * s} y={w[1] - 6 * s} width={12 * s} height={12 * s} fill="#22d3ee" stroke="#fff" strokeWidth={1.5 * s} draggable
                onDragMove={(e) => {
                  const r = resizeField(f, poly0, side, ptrUV(e, f), i);
                  e.target.position({ x: w[0] - 6 * s, y: w[1] - 6 * s });
                  setPrev({ rid: f.roof.id, i, poly: r.poly, text: tr("{0} × {1} moduli", [r.cols, r.rows]) });
                }}
                onDragEnd={() => prev && done(prev.poly)} />;
            })}
            {isSel && canEdit && pts.map((w, k) => (
              <Circle key={k} name={`field-vertex-${k}`} x={w[0]} y={w[1]} radius={6 * s} fill="#fff" stroke="#22d3ee" strokeWidth={2 * s} draggable
                onDragMove={(e) => {
                  const ll = toLL(e.target.getStage().getRelativePointerPosition());
                  setPrev({ rid: f.roof.id, i, poly: poly0.map((q, j) => (j === k ? ll : q)) });
                }}
                onDragEnd={() => prev && done(prev.poly)} />
            ))}
            {prev && prev.rid === f.roof.id && prev.i === i && prev.text && (() => {
              const c = llToWorld(f.frame.toLL([(U0 + U1) / 2, (V0 + V1) / 2]));
              return (
                <Label x={c[0]} y={c[1]} listening={false}>
                  <Tag fill="#0f172a" cornerRadius={3 * s} />
                  <Text text={prev.text} fontSize={13 * s} padding={5 * s} fill="#a5f3fc" fontStyle="bold" />
                </Label>
              );
            })()}
          </Group>
        );
      })}
    </Group>
  );
};
